import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { AgxNotificationBox, IconTaskTypes } from '@urbanx/agx.ui-components2';
import { useSelectedCampaign } from 'hooks';
import { JSX } from 'react';
import AgreementComplianceModal from 'pages/allTasks/TaskModal/AgreementComplianceModal';
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry';
import { useTaskModalState } from 'pages/allTasks/TaskModal/useTaskModalState';

interface AgreementComplianceProps {
  task: AutopilotTaskDto;
  badge: JSX.Element;
  onCompleteSuccess: () => void;
}

const AgreementCompliance = ({ task, badge, onCompleteSuccess }: AgreementComplianceProps) => {
  const { campaign } = useSelectedCampaign();
  const modalState = useTaskModalState([task]);
  const modalTask = modalState.modalTasks[0];

  if (!modalTask) throw new Error('Agreement Compliance modal task is missing');

  return (
    <>
      {campaign?.campaignId && (
        <AgreementComplianceModal
          task={modalTask}
          isOpen={modalState.isOpen}
          onClose={modalState.close}
          onCompleteSuccess={onCompleteSuccess}
          campaignId={campaign.campaignId}
          campaign={campaign}
        />
      )}
      <TaskModalEntry
        title="Agreement Compliance"
        tasks={[task]}
        badge={badge}
        iconType={IconTaskTypes.AgreementCompliance}
        actionText="Complete Compliance Check"
        actionButtonId="completeComplianceCheckBtn"
        panelKey="AgreementCompliancePanel"
        onAction={modalState.open}
        notification={
          campaign?.flatCommissionBelowMinimumAlert ? (
            <AgxNotificationBox
              type="warning"
              heading=""
              body="Commission rate is low. Alert Admin Manager and confirm rate is correct before proceeding."
            />
          ) : undefined
        }
      />
    </>
  );
};
export default AgreementCompliance;
